import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { deleteFile, getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import { fetchModulo } from "./moduloSlice";


interface SesionState {
    status: string;
    error: string;
    sesion: {
        idSesion: number | null;
        idModulo: number | null;
        nombre: string | null;
        temas: string | null;
        valores: string | null;
        fileData: string | null;
        fecha: Date | null;
        linkSesion: string | null;
        estado: number | null;
    }

}

const initialState: SesionState = {
    status: 'idle',
    error: '',
    sesion: {
        idSesion: null,
        idModulo: null,
        nombre: null,
        temas: null,
        valores: null,
        fileData: null,
        fecha: null,
        linkSesion: null,
        estado: null
    }
}

export const fetchSesionAlumno = createAsyncThunk('fetchSesionAlumno', async ({ idModulo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 74;
    const { result, message, data } = await getData({ idsp, idModulo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchSesionEncargado = createAsyncThunk('fetchSesionEncargado', async ({ idModulo }: any, { dispatch, getState, rejectWithValue }) => {

    const idsp = 75;
    const { result, message, data } = await getData({ idsp, idModulo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchDetalleSesion = createAsyncThunk('fetchDetalleSesion', async ({ idSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 82;
    const { result, message, data } = await getData({ idsp, idSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const createSesioEncargado = createAsyncThunk('createSesioEncargado', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const sesionNew = selectSesion(state);
    const sesionAttributes = { ...sesionNew };
    const idsp = 70;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...sesionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (sesionAttributes.fileData !== null && sesionAttributes.fileData !== '') {
            const { result: resultRecurso, data: dataRecurso } = await getData({ idsp: 80, idSesion: data, titulo: "Guía: " + sesionAttributes.nombre }, getState, dispatch);
            if (resultRecurso) {
                const { result: resultFile } = await postFile({ idsp: 81, id: dataRecurso, dir: "sesion", fileData: sesionAttributes.fileData, fileName: dataRecurso }, getState, dispatch);
                if (!resultFile) {
                    alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
                }
            } else {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };

            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const modifySesion = createAsyncThunk('modifySesion', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const sesionNew = selectSesion(state);
    const sesionAttributes = { ...sesionNew };
    const idsp = 71;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...sesionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (sesionAttributes.fileData != null && sesionAttributes.fileData != '') {
            const { result: resultRecurso, message: mesageRecurso, data: dataRecurso } = await getData({ idsp: 80, idSesion: data, titulo: "Guía: " + sesionAttributes.nombre }, getState, dispatch);
            if (resultRecurso) {
                const { result: resultFile, message: mesageFile, data: dataFile } = await postFile({ idsp: 81, id: dataRecurso, dir: "sesion", fileData: sesionAttributes.fileData, fileName: dataRecurso }, getState, dispatch);
                if (!resultFile) {
                    alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
                }
            } else {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };

            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const createSesionAlumno = createAsyncThunk('createSesionAlumno', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const sesionNew = selectSesion(state);
    const sesionAttributes = { ...sesionNew };
    const idsp = 69;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...sesionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (sesionAttributes.fileData != null && sesionAttributes.fileData != '') {
            const { result: resultRecurso, message: mesageRecurso, data: dataRecurso } = await getData({ idsp: 80, idSesion: data, titulo: "Guía: " + sesionAttributes.nombre }, getState, dispatch);
            if (resultRecurso) {
                const { result: resultFile, message: mesageFile, data: dataFile } = await postFile({ idsp: 81, id: dataRecurso, dir: "sesion", fileData: sesionAttributes.fileData, fileName: dataRecurso }, getState, dispatch);
                if (!resultFile) {
                    alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
                }
            } else {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "GUÍA NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };

            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const updateEstadoSesion = createAsyncThunk('updateEstadoSesion', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const sesionNew = selectSesion(state);
    const sesionAttributes = { ...sesionNew }
    const estado = !sesionAttributes.estado;
    const idSesion = sesionAttributes.idSesion;
    const idsp = 72;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idSesion }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const deleteSesion = createAsyncThunk('deleteSesion', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const sesionNew = selectSesion(state);
    const sesionAttributes = { ...sesionNew }
    const idSesion = sesionAttributes.idSesion;
    const idsp = 73;
    let alert: AlertInterface;


    const { result: resultRec, message: messageRec, data: dataRec } = await getData({ idsp: 82, idSesion }, getState, dispatch);
    const { result, message, data } = await getData({ idsp, idSesion }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (resultRec && dataRec != null) {
            const { result: resultFile, message: mesageFile, data: dataFile } = await deleteFile(dataRec, getState, dispatch);
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const sesionSlice = createSlice({
    name: 'sesion',
    initialState,
    reducers: {
        setSesion: (state, action) => {
            state.sesion = !action.payload ? initialState.sesion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchDetalleSesion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDetalleSesion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                if (data && data.length > 0) {
                    state.sesion = { ...state.sesion, ...data[0] };
                }
            })
            .addCase(fetchDetalleSesion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectSesion = (state: RootState) => state.sesion.sesion;

export const { setSesion } = sesionSlice.actions;

export default sesionSlice.reducer;
